import request from '@/utils/request'

export function updatePushCfg(data) {
  return request({
    url: 'api/v1/push-cfg/update',
    method: 'post',
    data: data
  })
}

export function getPushList(data) {
  return request({
    url: 'api/v1/push-cfg/getList',
    method: 'post',
    data: data
  })
}

export function getPushType(data) {
  return request({
    url: 'api/v1/push-cfg/getPushType',
    method: 'post',
    data: data
  })
}

export function getPushClassType(data) {
  return request({
    url: 'api/v1/push-cfg/getPushClassType',
    method: 'post',
    data: data
  })
}

export function exportPushCfg(data) {
  return request({
    url: 'api/v1/push-cfg/exportPushCfg',
    method: 'post',
    data: data
  })
}

export function importPushCfg(data) {
  return request({
    url: 'api/v1/push-cfg/importPushCfg',
    method: 'post',
    data: data
  })
}

export function PushMsg(data) {
  return request({
    url: 'api/v1/push-cfg/pushMsg',
    method: 'post',
    data: data
  })
}

export function delPush(data) {
  return request({
    url: 'api/v1/push-cfg/delPush',
    method: 'delete',
    data: data
  })
}
